const featureAccess = {
    basic: ["support", "billingInfo"],
    standard: ["support", "billingInfo", "notifications", "tripHistory"],
    premium: ["support", "billingInfo", "notifications", "tripHistory"],
    admin: ["support", "billingInfo", "notifications", "tripHistory", "csvUpload", "createUser"],
  };
  
  const tripHistoryLimits = {
    basic: 0,
    standard: 30,
    premium: 90,
    admin: Infinity,
  };
  
  export const hasFeatureAccess = (tier, feature) => {
    return featureAccess[tier]?.includes(feature) || false;
  };
  
  export const getTripHistoryLimit = (tier) => {
    return tripHistoryLimits[tier] || 0;
  };
  
  export const filterTripHistory = (trips, tier) => {
    const limitDays = getTripHistoryLimit(tier);
    if (limitDays === 0) return [];
    if (limitDays === Infinity) return trips;
  
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - limitDays);
    return trips.filter((trip) => new Date(trip.date) >= cutoffDate);
  };